// @flow
import React, { Component } from 'react';
import classnames from 'classnames';
import './TokenModal.scss';

type Props = {
  jwtToken: string,
  showModal: boolean,
  handleClose: Function,
}

export default class TokenModal extends Component {
  constructor(props: Props) {
    super(props);
    this.textArea = null;
  }

  copyToClipboard = (event: Object) => {
    this.textArea.select();
    document.execCommand('copy');
    event.target.focus();
  };

  render() {
    return (
      <div
        className={classnames('modal TokenModal', {
          'is-active': this.props.showModal,
        })}
        role="dialog"
      >
        <div
          className="modal-background" onClick={() => {
            this.props.handleClose();
          }}
        />
        <div className="modal-card">
          <header className="modal-card-head">
            <p className="modal-card-title">New JWT Token</p>
            <button
              className="delete"
              aria-label="close"
              onClick={this.props.handleClose}
            />
          </header>
          <section className="modal-card-body">
            <p className="notification is-warning">
              Please note that you will not be able to see your token again after closing.
            </p>
            <textarea
              readOnly
              value={this.props.jwtToken}
              ref={(textarea) => {
                this.textArea = textarea;
              }}
              className="tokenTextArea"
            />
          </section>
          <footer className="modal-card-foot">
            <button
              className="button"
              onClick={this.copyToClipboard}
            >
              Copy Token
            </button>
            <button
              className="button"
              onClick={this.props.handleClose}
            >
              Close
            </button>
          </footer>
        </div>
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/js/views/token_management/TokenModal.js
 **/